import { isTokenEquivalent } from '@funkit/utils'

/** A token, named the way both the destination and the rail name one. */
export interface FiatAssetRef {
  /** Decimal chain id, e.g. `1151111081099710`. */
  chainId: string
  /** EVM contract address, or the SPL mint on Solana. */
  address: string
}

/**
 * Whether the rail already buys exactly what the destination holds, so the
 * purchased crypto can be delivered to the recipient's own address.
 *
 * Both sides are host-declared, so this asks nothing of the network. A flow
 * with no destination answers `false`: the deposit address it would skip is
 * what covers the swap.
 */
export function isDirectFiatDelivery({
  destination,
  rail,
}: {
  destination: FiatAssetRef | undefined
  rail: FiatAssetRef
}): boolean {
  if (destination === undefined) {
    return false
  }
  return isTokenEquivalent({
    firstTokenChainId: rail.chainId,
    firstTokenAddress: rail.address,
    secondTokenChainId: destination.chainId,
    secondTokenAddress: destination.address,
  })
}
